"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtGlanceResponseSchema = exports.AtGlanceSchema = void 0;
const zod_1 = require("zod");
const statusSummary = zod_1.z.object({
    count: zod_1.z.number(),
    total: zod_1.z.number(),
});
exports.AtGlanceSchema = zod_1.z.object({
    quotes: zod_1.z.union([
        zod_1.z.object({
            draft: statusSummary,
            pending: statusSummary,
            accepted: statusSummary,
        }),
        zod_1.z.null(),
    ]),
    jobs: zod_1.z.union([
        zod_1.z.object({
            toSchedule: statusSummary,
            scheduled: statusSummary,
            inProgress: statusSummary,
        }),
        zod_1.z.null(),
    ]),
    invoices: zod_1.z.union([
        zod_1.z.object({
            paid: statusSummary,
            pending: statusSummary,
            overdue: statusSummary,
        }),
        zod_1.z.null(),
    ]),
    todos: zod_1.z.union([
        zod_1.z.object({
            open: zod_1.z.number(),
        }),
        zod_1.z.null(),
    ]),
    openQuotes: zod_1.z.number(),
    jobsThisWeek: zod_1.z.number(),
    pendingInvoices: zod_1.z.number(),
    openTodos: zod_1.z.number(),
});
exports.AtGlanceResponseSchema = zod_1.z.object({
    data: exports.AtGlanceSchema,
});
